// working maintenance


import React, { useEffect, useRef, useState } from 'react';
import Top from '../Top';
import Leftsiderbar from '../home/allcmp/Leftsidebar';
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from 'react-router-dom';
import ConstructionIcon from '@mui/icons-material/Construction';




const useStyles = makeStyles(() => ({
    customTooltip: {
        backgroundColor: "black",
        fontSize: "15px"
    }
}));
const WorkingMaintenance = ()=>{
    const navigate = useNavigate();
    
    const classes = useStyles();
    const handleNewDevice = ()=>{
        navigate('/add-device');

    }

    return(
        <div className="">
            <div className="cmail">
                <Top />
            </div>
            <div className="wrp-dashbord">
                <div className="cemail-left">
                    <Leftsiderbar />
                </div>
                <div className="right-section">
                    <div className="add-btn-wrp add-btn-wrp2" id='working-up'>
                    <div className='working-page'>
                    <ConstructionIcon style={{width:'35%', height:'35%'}} />
            <h4>Work Under Maintenance</h4>
            </div>    
                    </div>
                </div>
            </div>
          

        </div>
    )
}
export default WorkingMaintenance;